var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataQuality(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.095 3.963a.571.571 0 00-.686-.428l-2.98.69a.571.571 0 00-.282.954l.65.673-3.474 3.1-1.804-1.71a.571.571 0 00-.806.021l-3.87 4.058a1.143 1.143 0 10.909 1.12c0-.125-.025-.241-.061-.353l3.456-3.624 1.772 1.678a.571.571 0 00.773.011l3.9-3.478.74.767a.571.571 0 00.964-.249l.793-2.953a.569.569 0 00.006-.277zM17.18 9.17a.571.571 0 00-.571.571v4.528a.571.571 0 01-.572.571H3.466a.571.571 0 01-.571-.571V3.983c0-.315.255-.571.57-.571h9.477a.571.571 0 100-1.143H3.466c-.947 0-1.714.767-1.714 1.714V14.27c0 .947.767 1.714 1.714 1.714h12.571c.947 0 1.715-.767 1.715-1.714V9.74a.571.571 0 00-.572-.571zm-.285 7.956H2.609a.571.571 0 000 1.143h14.286a.571.571 0 000-1.143z",
    stroke: "#FFF",
    strokeWidth: 0.1,
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataQuality);
export default __webpack_public_path__ + "static/assets/dataQuality.6f78cd93.svg";
export { ForwardRef as ReactComponent };